export const FETCH_PAYMENT_PLANS = "FETCH_PAYMENT_PLANS";
export const PAYMENT_CONFIRM = "PAYMENT_CONFIRM";
export const OTP_VERIFICATION = "OTP_VERIFICATION";
export const PAYMENT_VERIFICATION = "PAYMENT_VERIFICATION";
